import { daysOfWeek } from "@sellar-io/common";
import { createContext } from "react";

export const DeliveryAreaCreateContext = createContext<
  | {
      postcodes: string[];
      setPostcodes: (postcodes: string[]) => void;
      selectedDays: daysOfWeek[];
      setSelectedDays: (days: daysOfWeek[]) => void;
    }
  | undefined
>(undefined);
